import { render, staticRenderFns } from "./OrdersMissingPayments.vue?vue&type=template&id=61a1a03d&scoped=true"
import script from "./OrdersMissingPayments.vue?vue&type=script&lang=js"
export * from "./OrdersMissingPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a1a03d",
  null
  
)

export default component.exports